import { createSlice } from '@reduxjs/toolkit'
import { PaginationInfoInterface } from '../../components/shared/list/list';

const initialState = {
  loading: false,
  eventsList: [],
  error: null,
  paginationInfo: null,
  rooms: [],
  smartObjects: null
}

const slice = createSlice({
  name: 'eventsList',
  initialState: initialState,
  reducers: {
    getEventsListAction: (state, action) => {
      state.loading = true
      state.error = null
    },
    getEventsListSuccessAction:(state, action)=> {
      let paginationInfo : PaginationInfoInterface | null = {
        count: action.payload.events.count,
        pageSize: action.payload.events.page_size,
        pageCount: action.payload.events.page_count,
        next: action.payload.events.next,
        previous: action.payload.events.previous,
      }

      state.loading = false
      state.error = null
      state.eventsList = action.payload.events.results
      // @ts-ignore
      state.paginationInfo = paginationInfo
      state.rooms = action.payload.rooms
      state.smartObjects = action.payload.smartObjects
    },
    getEventsListErrorAction: (state, action) => {
      state.loading = false
      state.eventsList = []
      state.paginationInfo = null
      state.error = action.payload
    },
    getEventsListResetState: () => initialState,
  },
});

export const {
  getEventsListAction,
  getEventsListSuccessAction,
  getEventsListErrorAction,
  getEventsListResetState,
} = slice.actions

export default slice.reducer
